import React from "react";
import "../../global.css"; // optional if you want custom styling

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-top d-flex justify-between align-center">
        <div>
          <h3 className="footer-title">Infiniti Infotech</h3>
          <p>
            © {new Date().getFullYear()} Infiniti Infotech. All rights reserved.
          </p>
        </div>

        <div className="footer-links d-flex gap-4">
          {/* Legal */}
          <div className="footer-section">
            <h4>Legal</h4>
            {/* <ul className="d-flex gap-3">
              <li>
                <a href="#">Terms & Conditions</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Refund Policy</a>
              </li>
            </ul> */}
          </div>

          {/* Support */}
          <div className="footer-section">
            <h4>Support</h4>
            {/* <ul className="d-flex gap-3">
              <li>
                <a href="#">Help Center</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
              <li>
                <a href="#">Report an Issue</a>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
